import { Injectable } from '@angular/core';
import { ProfileType } from '@capital-access/profiles/common';
import { ReportType } from '@capital-access/reporting/common';

@Injectable({ providedIn: 'root' })
export class ReportTypeMapperService {
  // Map ProfileType to ReportType
  mapProfileTypeToReportType(profileType: ProfileType): ReportType {
    switch (profileType) {
      case ProfileType.Contact:
        return ReportType.Contact;
      case ProfileType.Institution:
        return ReportType.Institution;
      default:
        return ReportType.None; // fallback
    }
  }
}
